import React, { useState, useEffect } from "react";
import SmartWidget from "../Components/SmartWidget";
import SWEventStructure from "../Components/SWEventStructure";
import axios from "axios";
import { useParams } from "react-router-dom";

export default function Template() {
  const { pathName } = useParams();
  const [widget, setWidget] = useState(false);
  useEffect(() => {
    const getWidget = async () => {
      try {
        const data = await axios.post(pathName ? `/${pathName}` : "/");
        const widgetData = data.data;
        setWidget(widgetData);
      } catch (err) {
        console.log(err);
      }
    };
    getWidget();
  }, []);

  return (
    <div className="fit-container fx-centered " style={{ gap: 0 }}>
      <SmartWidget widget={widget} onNextWidget={setWidget} />
      <SWEventStructure widget={widget} />
    </div>
  );
}
